"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var polished_1 = require("polished");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var _utilities_1 = require("../../../utilities");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: ", ";\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0px ", " ", " 0 rgba(0, 0, 0, 0.1);\n  font-size: ", ";\n  font-weight: 500;\n  color: ", ";\n  font-family: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: ", ";\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0px ", " ", " 0 rgba(0, 0, 0, 0.1);\n  font-size: ", ";\n  font-weight: 500;\n  color: ", ";\n  font-family: ", ";\n"])), polished_1.rem(12), function (_a) {
  var theme = _a.theme;
  return polished_1.lighten(0.37, theme.color.danger);
}, function (_a) {
  var theme = _a.theme;
  return theme.largeBorderRadius;
}, polished_1.rem(1), polished_1.rem(5), polished_1.rem(16), function (_a) {
  var theme = _a.theme;
  return theme.color.danger;
}, function (_a) {
  var theme = _a.theme;
  return theme.fontFamily;
});
var Description = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  font-weight: 400;\n  font-size: ", ";\n"], ["\n  text-align: center;\n  font-weight: 400;\n  font-size: ", ";\n"])), polished_1.rem(12));

var PrivateContentBoundary = function (_a) {
  var renderEmpty = _a.renderEmpty;
  return react_1["default"].createElement(Wrapper, null, _utilities_1.__('Zamknutý obsah'), !!renderEmpty && react_1["default"].createElement(Description, null, _utilities_1.__('Za touto hranicou nasleduje zamknutý obsah')));
};

exports["default"] = PrivateContentBoundary;
var templateObject_1, templateObject_2;